import React, { useState } from "react";
import GalleryButton from "./GalleryButton";
// import GalleryCard from "./GalleryCard";
import GalleryCard2 from "./GalleryCard2";
import dance1 from "../../../images/galleryimage/dance1.jpeg";
import dance2 from "../../../images/galleryimage/dance2.jpeg";
import dance3 from "../../../images/galleryimage/dance3.jpeg";
import dance4 from "../../../images/galleryimage/dance4.jpeg";
import dance5 from "../../../images/galleryimage/dance5.jpeg";
import dance6 from "../../../images/galleryimage/dance6.JPG";
import dance7 from "../../../images/galleryimage/dance7.JPG";
import dance8 from "../../../images/galleryimage/dance8.JPG";
import exh1 from "../../../images/galleryimage/exh1.jpg";
import exh2 from "../../../images/galleryimage/exh2.jpg";
import exh3 from "../../../images/galleryimage/exh3.jpg";
import exh4 from "../../../images/galleryimage/exh4.jpg";
import exh5 from "../../../images/galleryimage/exh5.jpg";
import exh6 from "../../../images/galleryimage/exh6.jpg";
import exh7 from "../../../images/galleryimage/exh7.jpg";
import exh8 from "../../../images/galleryimage/exh8.jpg";
import all1 from "../../../images/galleryimage/all1.JPG";
import all2 from "../../../images/galleryimage/all2.JPG";
import all3 from "../../../images/galleryimage/all3.JPG";
import all4 from "../../../images/galleryimage/all4.JPG";
import all5 from "../../../images/galleryimage/all5.JPG";
import all6 from "../../../images/galleryimage/all6.JPG";
import all7 from "../../../images/galleryimage/all7.JPG";
import all8 from "../../../images/galleryimage/all8.JPG";
import compt1 from "../../../images/galleryimage/compt1.jpg";
import compt2 from "../../../images/galleryimage/compt2.jpeg";
import compt3 from "../../../images/galleryimage/compt3.jpeg";
import compt4 from "../../../images/galleryimage/compt4.jpeg";
import compt5 from "../../../images/galleryimage/compt5.jpeg";
import compt6 from "../../../images/galleryimage/compt6.jpeg";
import play6 from "../../../images/galleryimage/play6.jpeg";
import play10 from "../../../images/galleryimage/play10.jpeg";
const GallerySection1 = () => {
  const [first, setfirst] = useState("ALL");
  return (
    <div id="photo overflow-hidden ">
      <div className="mt-24 bg-gray-50 pt-24 pb-14 lg:mt-44 lg:px-20">
        <div className=" justify-between text-center lg:flex">
          <div className="mt-10">
            <h1 className="text-4xl lg:text-6xl font-bold">GALLERY</h1>
          </div>
          <div className="mt-10">
            <GalleryButton title="ALL" func={setfirst} />
            {/* <GalleryButton title="ACTIVITIES" func={setfirst} /> */}
            <GalleryButton title="DANCE" func={setfirst} />
            <GalleryButton title="COMPETITIONS" func={setfirst} />
            <GalleryButton title="EXHIBITION" func={setfirst} />
          </div>
        </div>

        {first === "ALL" && (
          <div className="mx-4 mt-40">
            <div className="justify-evenly my-10 lg:flex">
              <GalleryCard2 title="ALL" image={all1} />
              <GalleryCard2 title="ALL" image={all2} />
              <GalleryCard2 title="ALL" image={all3} />
              <GalleryCard2 title="ALL" image={all4} />
            </div>
            <div className="justify-evenly my-10 lg:flex">
              <GalleryCard2 title="ALL" image={all5} />
              <GalleryCard2 title="ALL" image={all6} />
              <GalleryCard2 title="ALL" image={all7} />
              <GalleryCard2 title="ALL" image={all8} />
            </div>
          </div>
        )}

        {/* {first === "ACTIVITIES" && (
          <div className="mx-4 mt-40">
            <div className="justify-evenly my-10 lg:flex">
              <GalleryCard2
                title="ACTIVITIES"
                image={
                  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSNlzoXSh9SxJ46rky4k4faeS-FsjHZ73sdTcLMsI9YqqWkspQAZbBGwUpmsVKogMm8vOA&usqp=CAU"
                }
              />
              <GalleryCard2 title="ACTIVITIES" image={""} />
              <GalleryCard2 title="ACTIVITIES" image={""} />
              <GalleryCard2 title="ACTIVITIES" image={""} />
            </div>
            <div className="justify-evenly my-10 lg:flex">
              <GalleryCard2 title="ACTIVITIES" image={""} />
              <GalleryCard2 title="ACTIVITIES" image={""} />
              <GalleryCard2 title="ACTIVITIES" image={""} />
              <GalleryCard2 title="ACTIVITIES" image={""} />
            </div>
          </div>
        )} */}

        {first === "DANCE" && (
          <div className="mx-4 mt-40">
            <div className="justify-evenly my-10 lg:flex">
              <GalleryCard2 title="DANCE" image={dance1} />
              <GalleryCard2 title="DANCE" image={dance2} />
              <GalleryCard2 title="DANCE" image={dance3} />
              <GalleryCard2 title="DANCE" image={dance4} />
            </div>
            <div className="justify-evenly my-10 lg:flex">
              <GalleryCard2 title="DANCE" image={dance5} />
              <GalleryCard2 title="DANCE" image={dance6} />
              <GalleryCard2 title="DANCE" image={dance7} />
              <GalleryCard2 title="DANCE" image={dance8} />
            </div>
          </div>
        )}

        {first === "COMPETITIONS" && (
          <div className="mx-4 mt-40">
            <div className="justify-evenly my-10 lg:flex">
              <GalleryCard2 title="COMPETITIONS" image={compt1} />
              <GalleryCard2 title="COMPETITIONS" image={compt2} />
              <GalleryCard2 title="COMPETITIONS" image={compt3} />
              <GalleryCard2 title="COMPETITIONS" image={compt4} />
            </div>
            <div className="justify-evenly my-10 lg:flex">
              <GalleryCard2 title="COMPETITIONS" image={compt5} />
              <GalleryCard2 title="COMPETITIONS" image={compt6} />
              <GalleryCard2 title="COMPETITIONS" image={play6} />
              <GalleryCard2 title="COMPETITIONS" image={play10} />
            </div>
          </div>
        )}

        {first === "EXHIBITION" && (
          <div className="mx-4 mt-40">
            <div className="justify-evenly my-10 lg:flex">
              <GalleryCard2 title="EXHIBITION" image={exh1} />
              <GalleryCard2 title="EXHIBITION" image={exh2} />
              <GalleryCard2 title="EXHIBITION" image={exh3} />
              <GalleryCard2 title="EXHIBITION" image={exh4} />
            </div>
            <div className="justify-evenly my-10 lg:flex">
              <GalleryCard2 title="EXHIBITION" image={exh5} />
              <GalleryCard2 title="EXHIBITION" image={exh6} />
              <GalleryCard2 title="EXHIBITION" image={exh7} />
              <GalleryCard2 title="EXHIBITION" image={exh8} />
            </div>
          </div>
        )}

        {/* <div className="mx-4 mt-40">
        <GalleryCard />
        <GalleryCard />
      </div> */}
      </div>
    </div>
  );
};

export default GallerySection1;
